export default function Likeicon() {
    return (
        <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.12392 3.71484C3.89812 3.71484 2.09375 5.50208 2.09375 7.70672C2.09375 11.6986 6.85668 15.3276 9.42134 16.1717C11.986 15.3276 16.7489 11.6986 16.7489 7.70672C16.7489 5.50208 14.9445 3.71484 12.7188 3.71484C11.3557 3.71484 10.1507 4.38508 9.42134 5.41096C8.69199 4.38508 7.48696 3.71484 6.12392 3.71484Z" stroke="white" strokeWidth="1.09914" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}